<template>
  <div class="login-page">
      <van-form class="login-form"  @submit="onLoginSubmit" ref="loginForm">
        <div class="login-form-tittle">账号密码登录</div>
        <van-field
          border
          v-model="loginForm.phone"
          placeholder="请输入您的手机号码"
          :rules="rules.phone"
          :error-message="errMsg.phone"
        />
        <van-field
         class="login-form-password"
          border
          type="password"
          v-model="loginForm.password"
          placeholder="输入密码"
          :rules="rules.password"
          :error-message="errMsg.password"
        />
        <div class="login-form-validate">
          <van-field
            class="login-form-validate-realcode"
            border
            v-model="loginForm.webValidateCode"
            placeholder="输入验证码"
            :rules="rules.webValidateCode"
            :error-message="errMsg.webValidateCode"
          />
          <div class="login-form-validate-code">
            <tr-identify
              :contentWidth="146"
              @click="refreshCode"
              :contentHeight="51"
              :identifyCode="identifyCode"
            ></tr-identify>    
          </div>
        </div>
        <!-- 原生 button 标签的 type 属性native-type -->
        <van-button class="login-form-login" type="primary" native-type="submit">登录</van-button>
        <div class="other-entrance">
          <div @click="goRegist">新用户注册></div>
          <div class="forget-passward" @click="goForgetPassword">忘记密码?</div>
        </div>
      </van-form>
  </div>
</template>
<script>
import RequestPath from "@/utils/RequestPath";
import { checkPhoneUsed,login } from "@/axios/service/user";
import { Form,Button,Field } from 'vant';
import TrIdentify from "@/components/kits/identify";
import { errMsgCallback,mobileMsgSuc,mobileMsgErr } from "@/utils/MobileGlobal";
import {  mapMutations } from "vuex";
import api from "@/axios/api";
export default {
  name: "login-page",
  components: {
    [Field.name]: Field,
    [Form.name]: Form,
    [Button.name] : Button,
    TrIdentify
  },
  created() {
    let loginForm = this.$cookie.get("loginForm");
    //不是""和undefined
    if (loginForm) {
      let loginFormObj = JSON.parse(loginForm);
      this.loginFun(loginFormObj, this.apolloConfig);
    }
  },
  mounted() {
    this.identifyCode = "";
    this.makeCode(this.identifyCodes, 4); //生成4位验证码
  },
  data() {
    //检查密码(登录时候的密码校验只需要不为空就好)
    let checkPassword = (value,rule) => {
      if (value === "") {
        this.errMsg.password = "密码不能为空，请重新输入";
        return false;
      } else {
        this.errMsg.password = "";
        return true;
      }
    };
    // 校验函数返回 true 表示校验通过，false 表示不通过
    let phoneValidator = (value,rule) => {
      let that = this;
      let reg = /^(1[3456789][0-9]{9}$)/;
      if (value === "") {
        this.errMsg.phone  = "请输入11位手机号码";
        return false;
      } else {
        if (!reg.test(value)) {
          this.errMsg.phone  = "请输入11位手机号码";
          return false;
        } else {
          //调接口判断段手机号是否已经注册过
          //如果手机号格式校验通过，则调接口判断是否是已经注册的用户
          checkPhoneUsed({
            phone: value,
            oemId: that.apolloConfig.WORK.oemId
          }).then(json => {
            if (json.respCode === 100) {
              //如果是没有注册的手机号，提示
              if (!json.data.isUserExist) {
                this.errMsg.phone  = "该手机号码账号不存在";
                return false;
              } else {
                this.errMsg.phone  = "";
                return true;
              }
            } else {
              this.errMsg.phone  = "";
              return true;
            }
          });
        }
      }
    };
    //校验验证码
    let checkWebValidateCode = (value,rule) => {
      if (value === "") {
        this.errMsg.webValidateCode = "请输入验证码";
        return false;
      } else {
        if (value !== this.identifyCode) {
          // 增加逻辑：如果验证码输入错误超过三次，则自动刷新验证码
          this.identifyCount++;
          if (this.identifyCount === 4) {
            this.refreshCode();
          }
          this.errMsg.webValidateCode = "验证码输入有误，请重新输入";
          return false;
        }
        this.errMsg.webValidateCode = "";
        return true;
      }
    };
    return {
      loginForm: {
        typeId: "4",
        phone: "",
        password: "",
        webValidateCode: ""
      },
      identifyCodes: "1234567890",
      identifyCode: "",
      identifyCount: 0,
      rules: {
        phone: [{ required: true, message: "请输入手机号",validator: phoneValidator  }],
        password: [{ required: true, message: '请输入密码',validator: checkPassword }],
        webValidateCode: [{ required: true, message: '请输入验证码',validator: checkWebValidateCode }],
      },
      errMsg: {
        phone: "",
        webValidateCode: "",
        password: ""
      },
      loginError: {
        "-108": "用户名不存在",
        "-109": "密码错误",
        "-110": "登录应用错误",
        "-136": "管理员账号已失效"
      }
    };
  },
  watch: {
  },
  methods: {
    goRegist() {
      this.$router.push({name: "regist"});
    },
    goForgetPassword() {
      this.$router.push({name: "forget"});
    },
    refreshCode() {
      this.identifyCount = 0;
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[
          this.randomNum(0, this.identifyCodes.length)
        ];
      }
    },
    loginFun(loginForm, config) {
      let that = this;
      login({
        userName: loginForm.phone,
        webPhone: loginForm.phone,
        password: this.$md5(loginForm.password),
        webUserType: loginForm.typeId,
        productId: config.WORK.oemId,
        appId: config.WORK.appId
      })
        .then(res => {
          if (res.respCode === 100) {
            mobileMsgSuc("登录成功");
            //更新是否登录的变量
            this.$root.verificationLogin(true);
            //设置cookie
            this.setCookieAfterLogin(this.apolloConfig, res.data);
            //设置请求的baseURL
            this.setPath(this.apolloConfig, res.data);
            //设置token
            this.setToken(this.apolloConfig, res.data);
            //设置头像
            this.userAvatarMutations(res.data.userInfo.avatar);
            let path = localStorage.getItem("intentPath") || "/";
            this.$router.push({ path });
            localStorage.removeItem("intentPath");
            //账号或者密码错误（定位到密码的位置）
          } else if (res.respCode == -109) {
             this.errMsg.password = "账号或密码错误，请重新输入";
          } else {
            errMsgCallback(res, this.loginError);
          }
        })
        .finally(() => {
          this.btntext = "登录";
          this.loading = false;
        });
    },
    onLoginSubmit() {
      this.loginFun(this.loginForm, this.apolloConfig);
    },
    //验证码
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    setCookieAfterLogin(config, data) {
      this.$cookie.set("userInfo_productId", config.WORK.oemId, 7);
      this.$cookie.set("userInfo_appId", this.apolloConfig.WORK.appId, 7);
      this.$cookie.set("userInfo_userId", data.userInfo.userId, 7);
      this.$cookie.set("userInfo_refreshToken", data.loginInfo.refreshToken, 7);
      this.$cookie.set("userInfo_token", data.loginInfo.token, 7);
    },
    setPath(config, data) {
      RequestPath.webServiceInterface(
        config.WORK.oemId,
        config.WORK.appId,
        data.userInfo.userId,
        data.loginInfo.token
      );
      RequestPath.userInformatin(
        config.WORK.oemId,
        config.WORK.appId,
        data.userInfo.userId,
        data.loginInfo.token
      );
    },
    setToken(config, data) {
      api.setToken({
        oemId: config.WORK.oemId,
        appId: config.WORK.appId,
        userId: data.userInfo.userId,
        token: data.loginInfo.token,
        refreshToken: data.loginInfo.refreshToken
      });
    },
    ...mapMutations("PersonalStore", [
      "userAvatarMutations"
    ])
  },
  beforeDestroy() {
    //重置cookie中的loginform
    this.$cookie.set("loginForm","");
  }
};
</script>
<style lang="less">
@import "~@/mobile_css/login_related.less";
.login-page {
  .login-form {
    .common_layout();
    .login-form-password {
      margin-top:  @commonMarginTop;
    } 
    .login-form-tittle {
      .common_titile();
    }
    .van-field {
      .common_van_field();
    }
    .login-form-validate {
      margin-top:  @commonMarginTop;
      display: flex;
      align-items: center;
      justify-content: center;
      .login-form-validate-code {
        padding-left: 10px;
        padding-top: 4px;
        canvas {
          width: 120px;
        }
      }
    }
    .login-form-login {
      border-radius: 3px;
      margin-top: @baseMarginTop;
    }
    .other-entrance {
      margin-top: @baseMarginTop;
      font-size: @baseFontSize;
      display: flex;
      justify-content: space-between;
      .forget-passward {
        color: #fe9b01;
      }
    }
  }
}
</style>
